<template>
  <v-card v-if="editedItem">
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <slot name="dialog-text" :item="editedItem"> </slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn color="red darken-1" text @click="close">
          {{ $t("crudCommon.cancel") }}
        </v-btn>

        <v-btn color="red darken-1" text @click="save" :disabled="!valid">
          {{ $t("crudCommon.save") }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditItemForm",
  props: {
    con: null,
    editedItem: null,
  },
  data: () => ({
    valid: true,
  }),
  computed: {
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),

    formTitle() {
      return this.editedItem.id > 0
        ? this.con.locale["updateItem"]
        : this.con.locale["newItem"];
    },
  },
  methods: {
    ...mapActions("notificationModule", [
      "showNotification",
      "emptyErrorMessages",
    ]),

    save() {
      this.emptyErrorMessages();

      if (this.$refs.form.validate()) {
        if (this.editedItem.id > 0) {
          this.con.crud.update(this.editedItem).then(() => {
            this.clearError();
          });
        } else {
          this.con.crud.create(this.editedItem).then(() => {
            this.clearError();
          });
        }
      }
    },
    close() {
      this.$emit("closed");
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    },
    clearError() {
      if (this.errorBackend.length === 0) {
        this.close();
      } else {
        this.dialog = true;
        this.errors = true;
      }
    },
  },
};
</script>
